import styled from "styled-components";

const LinkText = ({ message }) => {
  return (
    <LinkWrapper>
      <p>{message}</p>
    </LinkWrapper>
  );
};

const LinkWrapper = styled.div`
  width: 400px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: #e4e4e4;
  }
  > p {
    font-family: "notoSans";
    font-size: 16px;
    color: #1167ed;
  }
`;

export default LinkText;
